module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/core-js/object/get-own-property-descriptor.js
// module id = 586
// module chunks = 23 41